import React from 'react';
import PropTypes from 'prop-types';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from './CustomDialog';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { trackEvent } from '../../../utils/ga-tracking';

const VoucherOfferPreviewDialog = ({ open, onRequestClose, voucherCampaign }) => {
  return (
    <CustomDialog hasFixedWidth={true} open={open} onRequestClose={onRequestClose}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body">
            <div dangerouslySetInnerHTML={{ __html: voucherCampaign.longText }} />
            <div className="voucher-dialog-image">
              <a
                href={voucherCampaign.url}
                onClick={() => trackEvent('Event', 'Voucher', 'Banner dialog')}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={voucherCampaign.banner} />
              </a>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button className="accept" onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.acceptButton"
                defaultMessage="Ok"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

VoucherOfferPreviewDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  voucherCampaign: PropTypes.object,
};

export default VoucherOfferPreviewDialog;
